import { HookCodes } from "@/data/enums/hooks";
import { TranslateResult } from "vue-i18n";

export type HookEventSlot = {
  slot: string;
  is: string;
  message: string;
  onClick?: () => void | Promise<void>;
};

type HookEventIcon = { name: string; type?: string; pack?: string };

export type EventParams = {
  path?: string;
  is?: string;
  icon?: HookEventIcon;
  slots?: (event) => HookEventSlot[];
  object?: any;
};

export type EventHook = {
  props: {
    path?: string;
  };
  is?: string;
  icon?: HookEventIcon;
  slots?: HookEventSlot[];
  timestamp: string;
};

export type EventMapType = (
  hookId: HookCodes,
  payload?: EventParams
) => {
  [key: string]: {
    name: string | TranslateResult;
    event: (arg: EventParams) => EventHook;
  };
};

export const createEventFunc = ({
  path,
  is = "i18n",
  icon = {
    name: "info-circle",
    type: "is-info"
  },
  slots = () => []
}: EventParams) => event => {
  return {
    props: {
      path
    },
    is,
    icon,
    timestamp: event.created_at,
    slots: slots(event)
  };
};

export const icon = {
  warning: {
    name: "exclamation-circle",
    type: "is-warning"
  },
  info: {
    name: "info-circle",
    type: "is-info"
  },
  success: {
    name: "check-circle",
    type: "is-success"
  },
  danger: {
    name: "trash-alt",
    pack: "far",
    type: "is-danger"
  },
  lock: { name: "lock" }
};
